import useIPA from '@/auth/jwt/useJwt'
import router from '@/router/index.js'

// initial state
const state = () => ({
  perPage: 5,
  pageOptions: [3, 5, 10],
  totalRows: 1,
  sortOptions: [],
  fields: [
    {
      key: 'id', label: 'Id',
    },
    { key: 'mode', label: 'Mode', sortable: true },
    { key: 'number', label: 'Number', sortable: true },
    'priority',
    'os',
    'min',
    'max',
    'note',
    'created_at',
    { key: 'status', label: 'Status', sortable: true },
    { key: 'action', label: 'Action'},
  ],
  items: []
})

// getters
const getters = {}

// actions
const actions = {
  getAll ({ commit }) {
    let param = {status: 'master/app-vers/status/AC'}
    useIPA.get(param).then(response => {
      const appver = {
        rows : response.data.data
      }
      commit('setData', {...appver})
    })
  },
  getById ({ commit }, id) {
		return new Promise((resolve, reject) => {
      let param = {status: 'master/app-ver/' + id}
      useIPA.get(param).then(response => {
          resolve(response.data.data)
      })
    })
  },
  formPostPut ({ commit }, formData) {
		return new Promise((resolve, reject) => {
      const rawData = {
        mode: formData.text_1,
        number: formData.text_2,
        priority: formData.select_3,
        os: formData.select_4,
        min: formData.text_5,
        max: formData.text_6,
        note: formData.text_7, 
        log: formData.text_8 
			}
      const param = { rawData: rawData, url: 'dashboard/master/app-ver', id: formData.id }
      useIPA.postput(param)
			.then(response => {
        router.push({ name: 'application-version' })
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	},
  remove ({ commit }, id) {
		return new Promise((resolve, reject) => {
      const param = { url: 'dashboard/master/app-ver', id: id }
      useIPA.delete(param)
			.then(response => {
        if (response.data.hasErrors) {
          reject(response.data.message)
        } else {
          resolve(response.data)
        }
      },
      error => {
        if (error.response.data.hasOwnProperty('hasErrors')) {
          reject(error.response.data.message)
        } else {
          reject(error.message)
        }
      })
		})
	}
}

// mutations
const mutations = {
  setData (state, appver) {
    state.items = appver.rows
    state.totalRows = appver.rows.length
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
